import _ from "lodash";

export function replaceObject<T extends object>(clean: T, src: T, deep: boolean) {
  _.keysIn(clean).forEach(key => {
    delete clean[key as keyof T]
  })
  _.keysIn(src).forEach(key => {
    clean[key as keyof T] = deep ? _.cloneDeep(src[key as keyof T]) : src[key as keyof T]
  })
  return clean
}

export function lockMethods(target: object) {
  const props = Object.getOwnPropertyNames(target);
  for (const key of props) {
    const desc = Object.getOwnPropertyDescriptor(target, key);
    if (desc && 'value' in desc && typeof desc.value === 'function') {
      Object.defineProperty(target, key, {
        value: desc.value,
        writable: false,
        configurable: false,
        enumerable: desc.enumerable,
      });
    }
  }
}

type MethodNames<T> = {
  [K in keyof T]: T[K] extends Function ? K : never;
}[keyof T];

type AnyObject = Record<string, any>;

export function bindAndFreezeMethods<T extends object>(instance: T): void {
  const protoChain: object[] = [];
  let proto = Object.getPrototypeOf(instance);

  // 收集原型链直到 Object.prototype
  while (proto && proto !== Object.prototype) {
    protoChain.push(proto);
    proto = Object.getPrototypeOf(proto);
  }

  for (const proto of protoChain) {
    const propNames = Object.getOwnPropertyNames(proto) as (keyof typeof proto)[];

    for (const name of propNames) {
      if (name === 'constructor') continue;

      const descriptor = Object.getOwnPropertyDescriptor(proto, name);
      const value = descriptor?.value;

      if (typeof value === 'function') {
        // 如果实例中尚未定义此方法，进行绑定并定义为不可更改
        if (!(name in instance)) {
          const boundFn = value.bind(instance);
          Object.defineProperty(instance, name, {
            value: boundFn,
            writable: false,
            configurable: false,
            enumerable: false,
          });
        }
      }
    }
  }

  Object.seal(instance); // 防止添加或删除属性
}
